
let showSuccessMessage = function (message, duration = 3) {
    this.$message({
        showClose: true,
        message: message || 'Successful Operation！',
        type: 'success',
        duration: duration * 1000,
      offset:100
    })
}

let showInfoMessage = function (message, duration = 3) {
    this.$message({
        showClose: true,
        message: message || 'Operation Tips！',
        type: 'info',
        duration: duration * 1000,
      offset:100
    })
}

let confirmEl = function(message,callback){
  this.$confirm(message.content,{
    confirmButtonText: message.confirmBtnText || 'logout',
    cancelButtonText: message.cancelBtnText || 'cancel',
    showClose:false,
    confirmButtonClass:'button_logout',cancelButtonClass:'button_cancel_logout'}).then(()=>{
    callback && callback();
  }).catch(()=>{

  })
}

let showErrorMessage = function (err, duration = 3, isForce = false) {
    let message = typeof err === 'object' && err !== null ? err.message : err
    if (isForce || !(err && err.isCancel)) {
        this.$message({
            showClose: true,
            message: message || 'Service Exceptions！',
            type: 'error',
            duration: duration * 1000,
          offset:100
        })
    }
}
export default{
    install (Vue) {
        Vue.prototype.$showErrorMessage = showErrorMessage
        Vue.prototype.$showSuccessMessage = showSuccessMessage
        Vue.prototype.$showInfoMessage = showInfoMessage
        Vue.prototype.$cmsConfirm = confirmEl
    }
}



// WEBPACK FOOTER //
// ./src/common/utils/project.js